// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2DLj4","content":"LayoutSettings_content__3XlmG"};